const baseURL = process.env.NEXT_PUBLIC_ACKO_DRIVE_CATALOG_SERVICE;

export const myProfileShortsFeed = async (page: number = 1, size: number = 10) => {
    try {
        const apiURL = `${baseURL}/api/feed/items?page=${page}&size=${size}`;

        const response = await fetch(apiURL, {
            method: 'GET',
            headers: {
            'Content-Type': 'application/json',
            },
        });

        const data = await response.json();
        return data.response;
    } catch (error) {
        console.error('Error fetching Shorts Feed :', error);
        return null;
    }
}